module.exports = __webpack_public_path__ + "img/profiles_0000_chestshot.005bcd14.png";